module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/img/issue-main-1200x630.d30d44b4.jpg";